import { Box, FlexLayout, H4, Icon } from '@deity/falcon-ui';
import type { IPropertyBag } from '@deity-io/di-data-basics';
import { mapRecord } from '@deity-io/di-data-basics';
import type { IPropertyList } from '@deity-io/di-data-structure-editor';
import type { FC } from 'react';
import { useState } from 'react';
import type { IContainerChildrenProps } from 'utils/IContainerChildrenProps';
import { getInputControlType, hasAControl } from './propertyListHelper';

type CollapsibleProps = {
  collapsed?: boolean;
  title: string;
  itemTitle?: string;
  propertyList?: IPropertyList;
  propertyBag?: IPropertyBag;
  countLabel?: string;
  actionButtons?: Array<any>;
};
export const Collapsible: FC<CollapsibleProps & IContainerChildrenProps> = ({
  title,
  collapsed = true,
  propertyList,
  propertyBag,
  itemTitle,
  countLabel,
  children,
  actionButtons = []
}) => {
  const [isCollapsed, setIsCollapsed] = useState(collapsed);
  let itemCount = 0;
  let valueCount = 0;
  // let errorCount = 0;

  if (propertyList) {
    mapRecord(propertyList, property => {
      const type = getInputControlType(property, {});
      if (type && hasAControl(type)) {
        // eslint-disable-next-line no-plusplus
        itemCount++;
        if (propertyBag && property.name in propertyBag) {
          // eslint-disable-next-line no-plusplus
          valueCount++;
        }
      }

      return undefined;
    });
  }
  const cLabel = countLabel || `${valueCount}/${itemCount}`;
  const titleLabel = itemTitle ? `${cLabel} ${itemTitle}` : `${cLabel}`;

  return (
    <Box width="full" mb="xs">
      <FlexLayout
        justifyContent="space-between"
        alignItems="center"
        p="xs"
        css={{
          cursor: 'pointer',
          borderBottom: !isCollapsed ? '1px solid #dfe1e6' : 'none'
        }}
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <H4 color="primaryText" fontSize={'llg' as any} style={{ textTransform: 'capitalize' }}>
          {title}
        </H4>
        <FlexLayout alignItems="center">
          {actionButtons}
          <H4 color="secondary">{titleLabel}</H4>
          <Icon src={isCollapsed ? 'unfoldMoreRounded' : 'unfoldLessRounded'} stroke="transparent" color="secondary" />
        </FlexLayout>
      </FlexLayout>
      <Box
        css={{
          overflowY: isCollapsed ? 'hidden' : 'visible',
          height: isCollapsed ? 0 : 'auto'
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
